import { createRoot, hydrateRoot } from 'react-dom/client';
import '../../web/src/theme.css';
import './styles/site.css';
import { i18n } from './locale/i18n.js';
import { App } from './app.jsx';
import { localeFromSegment, SUPPORTED_URL_LOCALES } from '../../shared-site-web/locales.js';

// Match i18next to the URL language before the first render so visitors
// don't flash English content, and tell the browser (e.g. Safari Translate)
// the page language via the <html lang> attribute. URL segments are lowercase
// (/zh-cn), so map them to the canonical locale code first (/en-us → en-US).
const initialUrlLang = SUPPORTED_URL_LOCALES.find((lang) => new RegExp(`^/${lang}(?:/|$)`).test(window.location.pathname)) || 'en';
const initialLang = localeFromSegment(initialUrlLang);
i18n.changeLanguage(initialLang);
document.documentElement.lang = initialLang;

const rootEl = document.getElementById('root');
if (rootEl) {
	if (rootEl.childNodes.length > 0) {
		// Prerendered HTML from the build — hydrate it into the SPA.
		hydrateRoot(rootEl, <App />);
	} else {
		// Vite dev server serves an empty root.
		createRoot(rootEl).render(<App />);
	}
}
// The standalone 404.html has no #root — it is intentionally not a React app.
